// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-tray {
  position: absolute;
  bottom: 20px;
  left: 28px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: auto;
}

/* Standalone HTN map skill-tree tray. The base .player-tray corner spot is
   taken by the map HP indicator (.map-hp, left:24), so on the standalone HTN
   surface the skill-tree orb is pushed to the RIGHT of the HP bar: the bar's
   right edge (24 + its responsive width) + a 12px gap, tracking the bar's own
   width so the pair stays glued and compact-safe at narrow viewports.
   Positions swapped 2026-07-20 (Edward).
   Scoped to .player-tray--hp-anchored (set ONLY by StandaloneHtnSurface via the
   hpAnchored prop), NOT the shared .player-tray--skill-only: the Landing /play
   demo also renders a skill-only tray but has no HP bar to sit beside, so it
   keeps the base corner position. The base .player-tray (main-app Dashboard) is
   likewise untouched. */
.player-tray--skill-only.player-tray--hp-anchored {
  left: calc(24px + min(348px, calc(100vw - 96px)) + 12px);
}

/* MAP-scoped orb lift (Edward 2026-07-24). The map HP bar (.map-hp) sits on the
   bottom loadout level, so the skill-tree orb lifts to the ROW ABOVE the bar,
   left-aligned with the bar's 27px inset. Scoped via .deck-map-area:has(.map-hp):
   .map-hp renders ONLY out of combat ({!htnCombatActive}), so this override applies
   ONLY on the map view. In combat (.map-hp absent) the rule above still governs the
   orb's position, so combat chrome is left completely untouched. bottom:59 = the
   bar's top edge (21 + 30 height) + an ~8px gap. */
.deck-map-area:has(.map-hp) .player-tray--skill-only.player-tray--hp-anchored {
  left: 27px;
  bottom: 59px;
}

.player-tray-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

/* VERTICAL divider between the game-orbs group and the tools group, inside the
   single inline row (Edward 2026-07-20). Subtle hairline that fades top+bottom,
   with a healthy horizontal margin on each side so the two groups read as one
   grouped tray without a hard rule. Stretches to the row's tile height so it
   reads as a full-height separator between the two clusters. */
.player-tray-divider {
  width: 1px;
  align-self: stretch;
  margin: 0 6px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.22) 20%,
    rgba(255, 255, 255, 0.22) 80%,
    rgba(255, 255, 255, 0)
  );
  border-radius: 1px;
}

/* PlayerTray widget tiles — viewport-adapted version of the TopNav action
   widgets (.settings-nav-button et al). Square 44×44 with rounded corners,
   neutral glass fill, hairline top edge for a subtle "embedded in the map"
   depth cue. Backdrop blur lets the map peek through faintly without
   diluting the glyph. The MapOrbTray carousel below is intentionally a
   different visual language — these tiles are tools, the carousel is
   gameplay state. */
.pt-orb {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background: rgba(10, 10, 14, 0.55);
  color: rgba(214, 211, 209, 0.78);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 4px 14px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  outline: none;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

.pt-orb:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.18);
  color: rgba(245, 245, 244, 0.96);
}

.pt-orb:active {
  transform: scale(0.96);
}

.pt-orb:focus-visible {
  border-color: rgba(239, 68, 68, 0.55);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 0 1px rgba(239, 68, 68, 0.45),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

/* Active map-mode tile (Drug Lab while the DrugLabMap is open). Amber accent —
   drugs are amber in the Debono palette, so this matches the retired DrugLabOrb
   and reads as "this surface is currently open". */
.pt-orb.pt-orb--active {
  border-color: rgba(245, 158, 11, 0.60);
  color: rgba(254, 243, 199, 1);
  background: rgba(245, 158, 11, 0.14);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 0 1px rgba(245, 158, 11, 0.35),
    0 4px 14px rgba(0, 0, 0, 0.45);
}

.pt-orb.pt-orb--active:hover {
  border-color: rgba(245, 158, 11, 0.78);
  background: rgba(245, 158, 11, 0.20);
  color: rgba(254, 243, 199, 1);
}

/* Legacy ring/pulse children from the orb era are kept in the JSX so the
   markup stays unchanged, but suppressed visually — squares don't spin. */
.pt-orb-ring {
  display: none;
}

/* Preprod-experimental marker — flags surfaces that show on preprod but
   are hidden in prod, so the prod-vs-preprod surface diff is visually
   obvious without inspecting source. Dashed amber outline + soft amber
   outer glow + a top-right "PREPROD" chip via ::after. Only the .pt-orb
   variant for now; pattern extends to any tile that adopts the class. */
.pt-orb.preprod-experimental {
  border: 1px dashed rgba(251, 191, 36, 0.85);
  box-shadow:
    0 0 0 1px rgba(251, 191, 36, 0.25),
    0 0 8px 2px rgba(251, 191, 36, 0.35),
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 4px 14px rgba(0, 0, 0, 0.45);
}

.pt-orb.preprod-experimental:hover {
  border-color: rgba(251, 191, 36, 1);
  box-shadow:
    0 0 0 1px rgba(251, 191, 36, 0.4),
    0 0 12px 3px rgba(251, 191, 36, 0.5),
    0 1px 0 rgba(255, 255, 255, 0.06) inset,
    0 4px 14px rgba(0, 0, 0, 0.5);
}

.pt-orb.preprod-experimental::after {
  content: 'PREPROD';
  position: absolute;
  top: -7px;
  right: -4px;
  font-size: 6px;
  font-weight: 700;
  letter-spacing: 0.6px;
  padding: 2px 4px;
  border-radius: 3px;
  background: rgba(251, 191, 36, 0.95);
  color: #0a0a0e;
  line-height: 1;
  pointer-events: none;
  z-index: 1;
}

/* ──────────────────────────────────────────
   Random Loadout button (no-signup landing) — sits to the RIGHT of the
   skill-tree orb in the skillTreeOnly tray. Matches .pt-orb's dark-glass
   treatment with the violet skill-tree accent so the pair reads as one unit.
   ────────────────────────────────────────── */
.pt-random-loadout {
  height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(167, 139, 250, 0.30);
  background: rgba(10, 10, 14, 0.55);
  color: rgba(196, 181, 253, 0.92);
  font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.10em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 4px 14px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

.pt-random-loadout:hover:not(:disabled) {
  background: rgba(167, 139, 250, 0.12);
  border-color: rgba(167, 139, 250, 0.55);
  color: rgba(237, 233, 254, 1);
}

.pt-random-loadout:active:not(:disabled) {
  transform: scale(0.97);
}

.pt-random-loadout:disabled {
  opacity: 0.6;
  cursor: default;
}

.pt-random-loadout svg {
  flex-shrink: 0;
  opacity: 0.9;
}

/* Dev-only "wipe state" pill (standalone /play demo, non-prod origin). Red tint
   to read as a destructive/dev affordance, distinct from the purple loadout pill. */
.pt-wipe-state {
  border-color: rgba(239, 68, 68, 0.35);
  color: rgba(252, 165, 165, 0.92);
}

.pt-wipe-state:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.55);
  color: rgba(254, 226, 226, 1);
}

/* Standalone /play demo dev wipe: anchored TOP-RIGHT of the map viewport
   (.deck-map-area is the positioning context). Moved out of the bottom-right
   corner (Edward 2026-07-09) so it no longer collides with / tracks the drug
   equip hotbar (.stoc-overlay). That coupling was hand-tuned magic numbers
   (right:21/bottom:64) measured against the loadout cluster's geometry, so it
   drifted out of place every time the cluster changed. Top-right is clear on
   the standalone demo (no top UserActionBar, no create/past-exam tray). Below
   the forced-equip gate scrim (z 100). */
.htn-demo-wipe {
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 40;
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayerTray/PlayerTray.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;;;;;;;;;wBAUwB;AACxB;EACE,wDAAwD;AAC1D;;AAEA;;;;;;mDAMmD;AACnD;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;+DAI+D;AAC/D;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb;;;;;;GAMC;EACD,kBAAkB;AACpB;;AAEA;;;;;;oBAMoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC;;kCAEgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,eAAe;EACf;;;;wBAIsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC;;;kCAGgC;AAClC;;AAEA;;mDAEmD;AACnD;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC;;;kCAGgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;0EAC0E;AAC1E;EACE,aAAa;AACf;;AAEA;;;;wEAIwE;AACxE;EACE,2CAA2C;EAC3C;;;;kCAIgC;AAClC;;AAEA;EACE,mCAAmC;EACnC;;;;iCAI+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;;;+CAI+C;AAC/C;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf;;kCAEgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC;;;;wBAIsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;oFACoF;AACpF;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;;;;;;yCAOyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb","sourcesContent":[".player-tray {\n  position: absolute;\n  bottom: 20px;\n  left: 28px;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  pointer-events: auto;\n}\n\n/* Standalone HTN map skill-tree tray. The base .player-tray corner spot is\n   taken by the map HP indicator (.map-hp, left:24), so on the standalone HTN\n   surface the skill-tree orb is pushed to the RIGHT of the HP bar: the bar's\n   right edge (24 + its responsive width) + a 12px gap, tracking the bar's own\n   width so the pair stays glued and compact-safe at narrow viewports.\n   Positions swapped 2026-07-20 (Edward).\n   Scoped to .player-tray--hp-anchored (set ONLY by StandaloneHtnSurface via the\n   hpAnchored prop), NOT the shared .player-tray--skill-only: the Landing /play\n   demo also renders a skill-only tray but has no HP bar to sit beside, so it\n   keeps the base corner position. The base .player-tray (main-app Dashboard) is\n   likewise untouched. */\n.player-tray--skill-only.player-tray--hp-anchored {\n  left: calc(24px + min(348px, calc(100vw - 96px)) + 12px);\n}\n\n/* MAP-scoped orb lift (Edward 2026-07-24). The map HP bar (.map-hp) sits on the\n   bottom loadout level, so the skill-tree orb lifts to the ROW ABOVE the bar,\n   left-aligned with the bar's 27px inset. Scoped via .deck-map-area:has(.map-hp):\n   .map-hp renders ONLY out of combat ({!htnCombatActive}), so this override applies\n   ONLY on the map view. In combat (.map-hp absent) the rule above still governs the\n   orb's position, so combat chrome is left completely untouched. bottom:59 = the\n   bar's top edge (21 + 30 height) + an ~8px gap. */\n.deck-map-area:has(.map-hp) .player-tray--skill-only.player-tray--hp-anchored {\n  left: 27px;\n  bottom: 59px;\n}\n\n.player-tray-row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n/* VERTICAL divider between the game-orbs group and the tools group, inside the\n   single inline row (Edward 2026-07-20). Subtle hairline that fades top+bottom,\n   with a healthy horizontal margin on each side so the two groups read as one\n   grouped tray without a hard rule. Stretches to the row's tile height so it\n   reads as a full-height separator between the two clusters. */\n.player-tray-divider {\n  width: 1px;\n  align-self: stretch;\n  margin: 0 6px;\n  background: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0),\n    rgba(255, 255, 255, 0.22) 20%,\n    rgba(255, 255, 255, 0.22) 80%,\n    rgba(255, 255, 255, 0)\n  );\n  border-radius: 1px;\n}\n\n/* PlayerTray widget tiles — viewport-adapted version of the TopNav action\n   widgets (.settings-nav-button et al). Square 44×44 with rounded corners,\n   neutral glass fill, hairline top edge for a subtle \"embedded in the map\"\n   depth cue. Backdrop blur lets the map peek through faintly without\n   diluting the glyph. The MapOrbTray carousel below is intentionally a\n   different visual language — these tiles are tools, the carousel is\n   gameplay state. */\n.pt-orb {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  background: rgba(10, 10, 14, 0.55);\n  color: rgba(214, 211, 209, 0.78);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 4px 14px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.pt-orb:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.18);\n  color: rgba(245, 245, 244, 0.96);\n}\n\n.pt-orb:active {\n  transform: scale(0.96);\n}\n\n.pt-orb:focus-visible {\n  border-color: rgba(239, 68, 68, 0.55);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 0 1px rgba(239, 68, 68, 0.45),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n/* Active map-mode tile (Drug Lab while the DrugLabMap is open). Amber accent —\n   drugs are amber in the Debono palette, so this matches the retired DrugLabOrb\n   and reads as \"this surface is currently open\". */\n.pt-orb.pt-orb--active {\n  border-color: rgba(245, 158, 11, 0.60);\n  color: rgba(254, 243, 199, 1);\n  background: rgba(245, 158, 11, 0.14);\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 0 1px rgba(245, 158, 11, 0.35),\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n.pt-orb.pt-orb--active:hover {\n  border-color: rgba(245, 158, 11, 0.78);\n  background: rgba(245, 158, 11, 0.20);\n  color: rgba(254, 243, 199, 1);\n}\n\n/* Legacy ring/pulse children from the orb era are kept in the JSX so the\n   markup stays unchanged, but suppressed visually — squares don't spin. */\n.pt-orb-ring {\n  display: none;\n}\n\n/* Preprod-experimental marker — flags surfaces that show on preprod but\n   are hidden in prod, so the prod-vs-preprod surface diff is visually\n   obvious without inspecting source. Dashed amber outline + soft amber\n   outer glow + a top-right \"PREPROD\" chip via ::after. Only the .pt-orb\n   variant for now; pattern extends to any tile that adopts the class. */\n.pt-orb.preprod-experimental {\n  border: 1px dashed rgba(251, 191, 36, 0.85);\n  box-shadow:\n    0 0 0 1px rgba(251, 191, 36, 0.25),\n    0 0 8px 2px rgba(251, 191, 36, 0.35),\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 4px 14px rgba(0, 0, 0, 0.45);\n}\n\n.pt-orb.preprod-experimental:hover {\n  border-color: rgba(251, 191, 36, 1);\n  box-shadow:\n    0 0 0 1px rgba(251, 191, 36, 0.4),\n    0 0 12px 3px rgba(251, 191, 36, 0.5),\n    0 1px 0 rgba(255, 255, 255, 0.06) inset,\n    0 4px 14px rgba(0, 0, 0, 0.5);\n}\n\n.pt-orb.preprod-experimental::after {\n  content: 'PREPROD';\n  position: absolute;\n  top: -7px;\n  right: -4px;\n  font-size: 6px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  padding: 2px 4px;\n  border-radius: 3px;\n  background: rgba(251, 191, 36, 0.95);\n  color: #0a0a0e;\n  line-height: 1;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* ──────────────────────────────────────────\n   Random Loadout button (no-signup landing) — sits to the RIGHT of the\n   skill-tree orb in the skillTreeOnly tray. Matches .pt-orb's dark-glass\n   treatment with the violet skill-tree accent so the pair reads as one unit.\n   ────────────────────────────────────────── */\n.pt-random-loadout {\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(167, 139, 250, 0.30);\n  background: rgba(10, 10, 14, 0.55);\n  color: rgba(196, 181, 253, 0.92);\n  font-family: ui-monospace, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 4px 14px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.pt-random-loadout:hover:not(:disabled) {\n  background: rgba(167, 139, 250, 0.12);\n  border-color: rgba(167, 139, 250, 0.55);\n  color: rgba(237, 233, 254, 1);\n}\n\n.pt-random-loadout:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.pt-random-loadout:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.pt-random-loadout svg {\n  flex-shrink: 0;\n  opacity: 0.9;\n}\n\n/* Dev-only \"wipe state\" pill (standalone /play demo, non-prod origin). Red tint\n   to read as a destructive/dev affordance, distinct from the purple loadout pill. */\n.pt-wipe-state {\n  border-color: rgba(239, 68, 68, 0.35);\n  color: rgba(252, 165, 165, 0.92);\n}\n\n.pt-wipe-state:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.55);\n  color: rgba(254, 226, 226, 1);\n}\n\n/* Standalone /play demo dev wipe: anchored TOP-RIGHT of the map viewport\n   (.deck-map-area is the positioning context). Moved out of the bottom-right\n   corner (Edward 2026-07-09) so it no longer collides with / tracks the drug\n   equip hotbar (.stoc-overlay). That coupling was hand-tuned magic numbers\n   (right:21/bottom:64) measured against the loadout cluster's geometry, so it\n   drifted out of place every time the cluster changed. Top-right is clear on\n   the standalone demo (no top UserActionBar, no create/past-exam tray). Below\n   the forced-equip gate scrim (z 100). */\n.htn-demo-wipe {\n  position: absolute;\n  top: 20px;\n  right: 24px;\n  z-index: 40;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
